import React from "react";

function CustomLoadingindicator() {
  return (
    <div
      style={{
        height: "80vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "16px",
      }}
    >
      <div
        style={{
          width: "44px",
          height: "44px",
          border: "4px solid #e2e8f0",
          borderRadius: "50%",
          borderTopColor: "#14b8a6",
          borderRightColor: "#06433e",
          animation: "crm-spin 0.75s linear infinite",
        }}
      />
      <span
        style={{
          fontSize: "13px",
          fontWeight: "600",
          color: "#64748b",
          letterSpacing: "0.3px",
        }}
      >
        Loading...
      </span>
      <style>
        {`
          @keyframes crm-spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}

export default CustomLoadingindicator;
